import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("全部人员");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("自定义人员");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getSalesmanBySupplierId, getAuditPerson } from '@/request';
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddSalesmanModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    reviewer: {
      type: Number,
      default: 1
    },
    supplierId: [String, Number],
    auditParams: Object,
    mode: String,
    getAuditPersonFn: Function
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const route = useRoute();

    const _getAuditPerson = params => (props.getAuditPersonFn || getAuditPerson)(params); // const supplierId = route.query.supplierId;


    const supplierId = ref(props.supplierId).value;
    const table = ref();
    const isAuditAll = ref(1);
    const keyWord = ref('');
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        keyWord.value = '';
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    watch(() => isAuditAll.value, () => {
      table.value.commitProxy('reload');
    });
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const tableOptions = computed(() => {
      let checkType = undefined;

      if (props.mode === 'single') {
        checkType = 'radio';
      } else {
        checkType = 'checkbox';
      }

      return getVexTableProps({
        pagerConfig: {
          pageSize: 10
        },
        toolbarConfig: {
          slots: {
            buttons: 'tools'
          }
        },
        columns: [{
          type: checkType,
          width: '50px',
          fixed: 'left'
        }, {
          title: '登录账号',
          field: 'loginName',
          width: '150px',
          showOverflow: true
        }, // {
        //   title: '供应商',
        //   field: 'supplierName',
        //   width: '150px',
        //   showOverflow: true
        // },
        {
          title: '联系人',
          field: 'linkMan',
          width: '150px',
          showOverflow: true
        }, {
          title: '角色名称',
          field: 'businessCategory',
          width: '150px',
          showOverflow: true
        }, // {
        //   title: '维护站点',
        //   field: 'salesmanBranchNameCover',
        //   showOverflow: true
        // }
        {
          title: '团队',
          field: 'supplierName',
          showOverflow: true
        }],
        proxyConfig: {
          ajax: {
            query: ({
              page
            }) => new Promise(res => {
              if (isAuditAll.value === 1 && props.reviewer === 2) {
                // 全部 被审核 人员
                res({
                  total: 1,
                  result: [{
                    businessCategory: '——',
                    linkMan: 'ALL',
                    loginName: '——',
                    salesmanBranchNameCover: '——',
                    supUserId: -1,
                    supplierId: 150,
                    supplierName: '——'
                  }]
                });
              }

              _getAuditPerson(_objectSpread({
                page: page.currentPage,
                rows: page.pageSize,
                supplierId,
                keyWord: keyWord.value,
                reviewer: props.reviewer
              }, props.auditParams)).then(data => {
                res({
                  total: data.total,
                  result: data.rows
                });
              });
            })
          }
        }
      });
    });
    const dialogTitle = computed(() => props.reviewer === 1 ? '添加审核人' : '添加被审核人');

    function confirm() {
      let selectRows = [];

      if (props.mode === 'single') {
        selectRows = [table.value.getRadioRecord()];
      } else {
        selectRows = table.value.getCheckboxRecords();
      }

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      emit('success', props.reviewer, selectRows);
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: _unref(dialogTitle),
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), {
          tools: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [__props.reviewer === 2 ? (_openBlock(), _createBlock(_component_el_radio_group, {
              key: 0,
              modelValue: isAuditAll.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isAuditAll.value = $event),
              size: "small"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1,
                size: "large"
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 0,
                size: "large"
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_el_input, {
              style: {
                "width": "200px",
                "margin": "0 10px"
              },
              modelValue: keyWord.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => keyWord.value = $event),
              placeholder: "登录账号/联系人"
            }, null, 8, ["modelValue"]), [[_vShow, isAuditAll.value === 0 || __props.reviewer === 1]]), _withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              style: {
                "margin-top": "4px"
              },
              onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            }, 512), [[_vShow, isAuditAll.value === 0 || __props.reviewer === 1]])]),
            _: 1
          })]),
          _: 1
        }, 16)]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }

};